import React from 'react';
import Home from './Home';
  import Links from './Links';
  import Contact from './Contact';
  import ChatLogin from './chat/ChatLogin';
import {NotFound} from './NotFound';
import { Switch, Route } from 'react-router-dom';
import './Main.css'

export const Main = () => (
  <main className="Main">
    <Switch>
      <Route exact path='/' component={Home}/>
      <Route path='/links' component={Links}/>
      <Route path='/contact' component={Contact}/>
      <Route path='/chat' component={ChatLogin}/>
     <Route path="*" component={NotFound}/>
    </Switch>
  </main>
)


// WEBPACK FOOTER //
// ./src/Main.js